import React, { Component } from 'react';
import { Col, Row, Modal } from 'react-materialize';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions/index';
import CompatabilityIndicator from './CompatabilityIndicator';
import Answer from './Answer';

class Player extends Component {
	constructor(props) {
		super(props);

		this.state = {
			messages: {
				pending: "Test your browser's video playback",
				fail: "Your browser's video playback didn't passed the test",
				success: "Your browser's video playback passed the test",
			},
			videoUrl:
				'https://pilotly-public.s3.amazonaws.com/video/player-tech-check.mp4',
			videoAnswers: [
				{ text: 'The cow jumped over the moon.', isCorrect: false },
				{ text: 'Bahh bahh black sheep.', isCorrect: false },
				{ text: 'The mouse ran up the clock.', isCorrect: true },
				{ text: 'Jack and Jill ran up the hill.', isCorrect: false },
				{ text: 'Pop goes the weasel.', isCorrect: false },
				{ text: 'None of the above.', isCorrect: false },
				{ text: "I can't see the video.", isCorrect: false },
			],
		};

		this.selectAnswer = this.selectAnswer.bind(this);
	}

	// TODO: `forceAutoPlay` should be called passing the function to Modal options.onOpenStart
	// as described in the docs https://react-materialize.github.io/react-materialize/?path=/story/javascript-modal--default
	// but the function isn't being called when passed on options object, probably because the library is outdated and not matching the current documentation
	// the code below is a workaround
	componentDidMount() {
		const trigger = document.querySelector('#test-player-trigger');
		trigger.onclick = this.forceAutoPlay;
	}

	forceAutoPlay() {
		const video = document.querySelector('#tech-check-video');
		video.currentTime = 0;
		video.play();
	}

	selectAnswer(answer) {
		if (!answer.isCorrect) this.props.onFail('Player');
		this.props.setTechCheckPlaybackTestAnswer(answer);
	}

	render() {
		return (
			<div>
				<div className="dp-instructions tech-check-test-title">
					Video Player
				</div>
				<Row>
					<Col s={12} m={6}>
						<div className="test-player-modal-container">
							<Modal
								id="test-player-modal"
								open={false}
								trigger={<button id="test-player-trigger">Test Player</button>}
							>
								<div className="modal-row">
									<div className="modal-column bg-black">
										<video
											id="tech-check-video"
											tabIndex={-1}
											width="100%"
											height="100%"
											autoPlay
											loop
										>
											<source src={this.state.videoUrl} />
										</video>
									</div>
									<div className="modal-column bg-white answers">
										<h4>What is the message in the video?</h4>
										<div className="test-player-answers">
											{this.state.videoAnswers.map((answer, index) => (
												<Answer
													key={answer.text}
													answer={answer}
													index={index}
													callback={this.selectAnswer}
													givenAnswer={this.props.playbackAnswer}
												/>
											))}
										</div>
									</div>
								</div>
							</Modal>
						</div>
					</Col>
					<Col s={12} m={6}>
						<CompatabilityIndicator
							state={this.props.player}
							messages={this.state.messages}
						/>
					</Col>
				</Row>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	playbackAnswer: state.techCheck.playbackAnswer,
	player: state.techCheck.player,
});

export default connect(mapStateToProps, actions)(Player);



// WEBPACK FOOTER //
// ./src/components/tech-check/Player.js